<script>
/* eslint-disable semi */
import { Component, Prop, Provide, Watch } from 'vue-property-decorator';
import { SasTable } from '@/core/ui';

@Component
export default class AppTable extends SasTable {
  @Prop({ require: true })
  model;

  @Prop({ require: false })
  schema;

  @Watch('model')
  onModelChanged () {
    this.provide.model = this.model;
  }

  /**
   * ElTableのdataプロパティ値
   * モデルがlist要素を持つオブジェクトの場合はmodel.list
   * そうでない場合はモデル自身をデータとして参照する
   */
  get innerData () {
    return (this.model) ? (('list' in this.model) ? this.model.list : this.model) : [];
  }

  /**
   * 下層コンポーネントへの公開プロパティ定義
   */
  provide = {
    model: {},
    schema: null
  }
  @Provide('_app_table') val = this.provide;

  /**
   * LifeCycleイベント
   */
  created () {
    // 下層コンポーネントへの公開プロパティを設定する
    // mountedのタイミングでは、先に下層コンポーネントの初期化が行われるので問題がある。
    this.provide.model = this.model;
    this.provide.schema = this.schema;
  }
}
</script>



// WEBPACK FOOTER //
// src/app/parts/table/AppTable.vue